import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.5s ease 0.1s;
`;

const StyledPanelControlsContainer = styled.div`
	position: absolute;
	bottom: 60px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 60px;
	transition: opacity 0.3s ease;
`;

export { StyledContainer, StyledPanelControlsContainer };
